import services from "@src/Services";
import { Column } from "@src/components/shared-ui-components/DataTable/types";
import {
  formatNumberWithCommaAndDollar,
  formatTimeUtctoEst,
  formatWithPercentage,
} from "@src/constants";
import { getCustomExtraPathTableDashboard } from "../../helper";

export const closedColumns: Column[] = [
  { id: "check_no", label: "Check#", minWidth: 113, freeze: true, link: true },
  {
    id: "time",
    label: "Time",
    minWidth: 87,
    align: "left",
  },
  {
    id: "revenue",
    label: "Total $",
    minWidth: 99,
    format: formatNumberWithCommaAndDollar,
  },
  {
    id: "tip_act",
    label: "Tips $",
    minWidth: 90,
    format: formatNumberWithCommaAndDollar,
  },
  {
    id: "tip_pct",
    label: "Tips %",
    minWidth: 90,
    format: formatWithPercentage,
  },
  {
    id: "server_name",
    label: "Server",
    minWidth: 140,
  },
  {
    id: "location",
    label: "Location",
    minWidth: 140,
  },
];

export const openColumns: Column[] = [
  { id: "check_no", label: "Check#", minWidth: 113, freeze: true, link: true },
  {
    id: "time",
    label: "Time",
    minWidth: 87,
    align: "left",
  },
  {
    id: "revenue",
    label: "Total $",
    minWidth: 99,
    format: formatNumberWithCommaAndDollar,
  },
  {
    id: "server_name",
    label: "Server",
    minWidth: 140,
  },
  {
    id: "location",
    label: "Location",
    minWidth: 140,
  },
];

export const refinedRowData = (mapData: CheckDashboardTableDataType[]) => {
  const data = mapData?.map((el: CheckDashboardTableDataType) => {
    return {
      check_no: el.check_no,
      time: el.time ? formatTimeUtctoEst(el.time) : el.time,
      revenue: el.revenue,
      tip_act: el.tip_act,
      tip_pct: el.tip_pct,
      server_name: el.server_name,
      location: el.location,
      property_short_name: el.property_short_name,
      total: el.total,
      type: el.notification_type,
    };
  });
  return data;
};

export const getCheckData = async (customFilter: CustomFilterType) => {
  try {
    const advancedFilterExtraPath = getCustomExtraPathTableDashboard({
      ...customFilter,
    });

    const customPath = `${advancedFilterExtraPath}`;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const res: any = await services.get(`/checks${customPath}`);

    if (!res?.error) {
      return { data: res?.data?.data };
    }
    return { data: null, error: "Something went wrong !" };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    return {
      error: err?.error?.message || "Something went wrong!",
    };
  }
};
